<template>
  <!-- 指示器在外层 -->
  <el-carousel indicator-position="outside" v-if="isChooseType == 1" class="custom-carousel">
    <el-carousel-item v-for="(item, i) in list" :key="i" @click="checkDetail(item)">
      <!-- <img src="../assets/image/swiper01.png" alt="" /> -->
      <div class="image-container">
        <img :src="item.img" alt="" class="carousel-image" />
      </div>
      <div class="carousel-title">
      <p text="2xl" justify="center">
        {{ item.title }}
      </p>
      </div>
    </el-carousel-item>
  </el-carousel>

  <!-- 卡片模式 -->
  <div class="card" v-if="isChooseType == 2"
    style="width: 100%;display: flex;flex-direction: row;justify-content: space-around;">
    <div class="slide" v-for="(item, i) in friendlyLink" :key="i" style="margin: 0 5px;">
      <a :href="item.link" target="_blank">
        <img style="width: 100%;height: 6vh;" :src="item.image" alt="" />
      </a>
    </div>
  </div>
  <!-- <el-carousel v-if="isChooseType == 2" :interval="500000" type="card" height="100px">
    <el-carousel-item v-for="(item, i) in friendlyLink" :key="i">
      <a :href="item.link" target="_blank">
        <img style="width: 100%;" :src="item.image" alt="" />
      </a>
    </el-carousel-item>
  </el-carousel> -->
</template>

<script lang="ts" setup>
import { ref, reactive, onMounted } from 'vue';
import { friendlyLink } from '@/pubilc/data';
import router from '@/router';

const props = defineProps({
  isChooseType: {
    type: String,
    default: ''
  },
  list: {
    type: Array,
    default: () => [] // 修改默认值为空数组
  }
})

// 检查列表数据是否有效
// const validList = computed(() => {
//   return props.list.filter(item => item && item.img); // 确保item和item.img存在
// });

// 配置Swiper选项
// const swiperOptions = reactive({
//   loop: true, // 开启循环模式
//   slidesPerView: 5, // 设置每屏显示的slides数量，可以根据需要调整
//   spaceBetween: 30, // 设置slides之间的间距
//   autoplay: { // 自动播放参数设置（可选）
//     delay: 7000, // 自动切换时间间隔
//     disableOnInteraction: false, // 用户操作后是否继续自动播放
//   },
// })

// 查看文章
const checkDetail = (item: any) => {
  if (item.id) { // 确保有id才跳转
    router.push({
      path: '/article',
      query: {
        id: item.id
      }
    })
  }
}
</script>

<style scoped lang="scss">
.custom-carousel {
  width: 100%;
  position: relative;
  
  /* 固定宽高比容器 */
  :deep(.el-carousel__container) {
    aspect-ratio: 16/9; /* 推荐比例16:9 */
    height: auto !important; /* 覆盖默认高度 */
  }
}

/* 图片容器 */
.image-container {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

/* 图片样式 */
.carousel-image {
  width: 100%;
  height: auto;
  /* 完整显示图片 */
  // object-fit: contain; 
  /* 填充容器（可能裁剪） */ 
  object-fit: cover; 
}


.el-carousel {
  width: 100%;
  position: relative;
}


.carousel-title {
  width: 100%;
  min-height: 40px; /* 最小高度，可根据需要调整 */
  max-height: 120px;
  padding: 8px 15px;
  margin: 0;
  font-size: 12px;
  position: absolute;
  bottom: 0;
  color: #ffffff;
  // background-color: #676b6d6a;
  background-color: rgba(91, 91, 91, 0.34);
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  white-space: normal; /* 关键修改 */
  word-wrap: break-word; /* 关键修改 */
  word-break: break-word; /* 关键修改 */
  overflow: hidden;
  box-sizing: border-box;
  line-height: 1.4; /* 行高调整 */
}

// 友情链接样式
.el-carousel__item {

  a {

    img {
      width: 100%;
      height: 100%;
    }
  }
}

</style>